module.exports = __webpack_public_path__ + "static/media/crypto-pay-amount.59ea49e0.png";